import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "addons" }
const _hoisted_2 = { class: "addons-header" }
const _hoisted_3 = { class: "addons-header__back" }
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = {
  key: 0,
  class: "addons-mobile_header"
}
const _hoisted_6 = { class: "h1" }
const _hoisted_7 = {
  key: 0,
  class: "addons-body"
}
const _hoisted_8 = { class: "addons-item--title" }
const _hoisted_9 = { class: "caption-large--bold" }
const _hoisted_10 = { class: "addons-item--description" }
const _hoisted_11 = {
  key: 0,
  class: "caption-medium color-text-secondary"
}
const _hoisted_12 = {
  key: 1,
  class: "caption-medium color-text-secondary"
}
const _hoisted_13 = { class: "addons-item--actions" }
const _hoisted_14 = { class: "addons-item--btn" }
const _hoisted_15 = { class: "addons-item--btn" }
const _hoisted_16 = {
  key: 1,
  class: "addons-loader"
}
const _hoisted_17 = { class: "addons-loader-pic" }
const _hoisted_18 = ["src"]

import BaseButton from "@/components/base/BaseButton.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import AddonsDetails from "@/components/addons/AddonsDetails.vue";
import { useAddonsPage } from "@/composables/addons/useAddonsPage";
import { useI18n } from "vue-i18n";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddonsPage',
  setup(__props) {

const { t } = useI18n();
const {
  addAddon,
  availableAddons,
  chosenAddon,
  closeAddModal,
  closeAllModal,
  computeAddonTitle,
  isAddonDetails,
  isAddAddon,
  isAlreadyAdded,
  isIncompatible,
  isLoading,
  isSticky,
  isSuccessful,
  isUnhandledError,
  isUnsuccessful,
  pageTitle,
  configDataBrand,
  showDetails,
  startAddonAction,
  toPayment,
} = useAddonsPage();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_unref(isAddonDetails))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "account"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(BaseFigureForIcon, {
                    size: "medium",
                    color: "white",
                    icon: "arrow",
                    position: "left",
                    "is-button": ""
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isAddonDetails))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "addons-header__back",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isAddonDetails.value = false))
            }, [
              _createVNode(BaseFigureForIcon, {
                size: "medium",
                color: "white",
                icon: "arrow",
                position: "left",
                "is-button": ""
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["addons-header__title", _unref(isSticky) ? 'visible' : ''])
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(pageTitle)), 1)
        ], 2),
        (_unref(isAddonDetails))
          ? (_openBlock(), _createBlock(BaseFigureForIcon, {
              key: 2,
              class: "addons-header__close",
              icon: "close",
              color: "white",
              size: "medium",
              "is-button": "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isAddonDetails.value = false))
            }))
          : _createCommentVNode("", true)
      ]),
      (!_unref(isAddonDetails))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(pageTitle)), 1)
          ]))
        : _createCommentVNode("", true),
      (!_unref(isAddonDetails))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_unref(isLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableAddons), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "addons-item"
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(item.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (Math.floor(parseInt(item.activation_price)) > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(item.activation_price) + "₽ " + _toDisplayString(_unref(t)("common.labels.perMonth")), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(t)("common.labels.free")), 1))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(BaseButton, {
                            size: "small",
                            title: _unref(t)('common.actions.details'),
                            color: "grey",
                            onClick: ($event: any) => (_unref(showDetails)(item))
                          }, null, 8, ["title", "onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(BaseButton, {
                            size: "small",
                            title: _unref(t)('common.actions.connect'),
                            onClick: ($event: any) => (_unref(startAddonAction)(item))
                          }, null, 8, ["title", "onClick"])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(isLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      src: _unref(configDataBrand).assets.loader,
                      alt: "Загрузка"
                    }, null, 8, _hoisted_18)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_unref(isAddonDetails) && _unref(chosenAddon))
        ? (_openBlock(), _createBlock(AddonsDetails, {
            key: 2,
            "chosen-addon": _unref(chosenAddon),
            onAction: _unref(startAddonAction)
          }, null, 8, ["chosen-addon", "onAction"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: ".root" }, [
      (_unref(isAddAddon) && _unref(chosenAddon))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 0,
            title: _unref(computeAddonTitle)(_unref(chosenAddon)),
            "main-btn-title": _unref(t)('common.actions.yes'),
            "secondary-btn-title": _unref(t)('common.actions.no'),
            onClose: _unref(closeAddModal),
            onAction: _cache[2] || (_cache[2] = ($event: any) => (_unref(addAddon)(_unref(chosenAddon).ems_product_id))),
            onSecondaryAction: _unref(closeAddModal)
          }, null, 8, ["title", "main-btn-title", "secondary-btn-title", "onClose", "onSecondaryAction"]))
        : _createCommentVNode("", true),
      (_unref(isSuccessful))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 1,
            title: _unref(t)('addons.modals.successTitle'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _unref(closeAllModal),
            onAction: _unref(closeAllModal)
          }, null, 8, ["title", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(isUnsuccessful))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 2,
            title: _unref(t)('addons.modals.insufficientFundsTitle'),
            text: _unref(t)('addons.modals.insufficientFundsText'),
            "main-btn-title": _unref(t)('common.buttons.topUpBalance'),
            onClose: _unref(closeAllModal),
            onAction: _unref(toPayment)
          }, null, 8, ["title", "text", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(isUnhandledError))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 3,
            title: _unref(t)('common.errors.title'),
            text: _unref(t)('common.errors.retryRequest'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _unref(closeAllModal),
            onAction: _unref(closeAllModal)
          }, null, 8, ["title", "text", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(isIncompatible))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 4,
            title: _unref(t)('common.errors.title'),
            text: _unref(t)('addons.modals.incompatibleText'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _unref(closeAllModal),
            onAction: _unref(closeAllModal)
          }, null, 8, ["title", "text", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(isAlreadyAdded))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 5,
            title: _unref(t)('common.errors.title'),
            text: _unref(t)('addons.modals.alreadyAddedText'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _unref(closeAllModal),
            onAction: _unref(closeAllModal)
          }, null, 8, ["title", "text", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})